import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ElectronicSignatureState } from './electronic-signature.state';

export const selectElectronicSignature =
  createFeatureSelector<ElectronicSignatureState>('electronicSignature');
